const ProductsSection = () => {
  return (
    <section id="products" className="py-24 lg:py-32 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(0, 0, 0, .05) 25%, rgba(0, 0, 0, .05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, .05) 75%, rgba(0, 0, 0, .05) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(0, 0, 0, .05) 25%, rgba(0, 0, 0, .05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, .05) 75%, rgba(0, 0, 0, .05) 76%, transparent 77%, transparent)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 space-y-4">
          <p className="text-sm uppercase tracking-widest text-gray-400 font-medium">Our Products</p>
          <h2 className="font-['Inter'] font-bold text-5xl lg:text-6xl text-gray-900">
            VPN &amp; Cleaner Applications
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10" data-product-shop>
          <div className="relative h-[680px] rounded-[32px] overflow-hidden group cursor-pointer">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-purple-600 to-purple-700"></div>
            <div className="absolute top-0 right-0 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-indigo-400/20 rounded-full blur-3xl"></div>
            
            <div className="relative h-full p-12 flex flex-col justify-between">
              <div className="flex justify-end">
                <img
                  src="https://public.readdy.ai/ai/img_res/4061bec2e9f71c82931e42e7f733b40c.jpg"
                  alt="VPN Application"
                  className="w-64 h-auto transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              <div className="space-y-6">
                <h3 className="font-['Inter'] font-bold text-4xl text-white">VPN</h3>
                <ul className="space-y-3">
                  <li className="text-white/90 text-base font-light flex items-start">
                    <i className="ri-shield-check-line text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                    <span>Military-grade encryption for ultimate privacy</span>
                  </li>
                  <li className="text-white/90 text-base font-light flex items-start">
                    <i className="ri-global-line text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                    <span>Access content from anywhere in the world</span>
                  </li>
                  <li className="text-white/90 text-base font-light flex items-start">
                    <i className="ri-speed-line text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                    <span>Lightning-fast connection speeds</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="relative h-[680px] rounded-[32px] overflow-hidden group cursor-pointer">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500 via-rose-500 to-orange-500"></div>
            <div className="absolute top-0 left-0 w-96 h-96 bg-pink-400/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-orange-400/20 rounded-full blur-3xl"></div>
            
            <div className="relative h-full p-12 flex flex-col justify-between">
              <div className="flex justify-start">
                <img
                  src="https://readdy.ai/api/search-image?query=iPhone%20mockup%20displaying%20Cleaner%20application%20interface%20with%20storage%20optimization%20graphics%2C%20clean%20modern%20UI%20design%2C%20pink%20and%20orange%20gradient%20theme%2C%20device%20performance%20metrics%20shown%2C%20professional%20mobile%20app%20screenshot%2C%20minimalist%20interface%20elements%2C%20premium%20iOS%20app%20design%2C%20cleaning%20progress%20indicators&width=400&height=600&seq=cleaner-product-001&orientation=portrait"
                  alt="Cleaner Application"
                  className="w-64 h-auto transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              <div className="space-y-6 text-right">
                <h3 className="font-['Inter'] font-bold text-4xl text-white">Cleaner</h3>
                <ul className="space-y-3">
                  <li className="text-white/90 text-base font-light flex items-end justify-end">
                    <span>Free up storage space instantly</span>
                    <i className="ri-delete-bin-line text-xl ml-3 mt-0.5 flex-shrink-0"></i>
                  </li>
                  <li className="text-white/90 text-base font-light flex items-end justify-end">
                    <span>Optimize device performance effortlessly</span>
                    <i className="ri-dashboard-line text-xl ml-3 mt-0.5 flex-shrink-0"></i>
                  </li>
                  <li className="text-white/90 text-base font-light flex items-end justify-end">
                    <span>Remove duplicate photos and files</span>
                    <i className="ri-file-reduce-line text-xl ml-3 mt-0.5 flex-shrink-0"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
